import React from 'react'
import { Controller, ControllerProps } from 'react-hook-form'
import { ISelectOption } from 'components/forms/Selects'
import { InputMultiSelect, IInputMultiSelectProps } from 'transfix-ui'

type IBaseControllerProps = ControllerProps<React.ComponentType>

export interface IControlledMultiSelectGroupInputProps
  extends Pick<IBaseControllerProps, 'defaultValue' | 'control'> {
  InputMultiSelectProps?: Omit<IInputMultiSelectProps, 'options'>
  options: ISelectOption[]
  name: string
}

interface IRenderProps {
  value: ISelectOption[]
  onChange: (newValue: ISelectOption[]) => void
}

const ControlledMultiSelectGroupInput = ({
  InputMultiSelectProps,
  control,
  defaultValue,
  name,
  options,
}: IControlledMultiSelectGroupInputProps) => {
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue || []}
      render={({ onChange, value }: IRenderProps) => {
        const changeHandler = (options: ISelectOption[]) => {
          onChange(options.map(({ value }) => value))
        }

        return (
          <InputMultiSelect
            {...InputMultiSelectProps}
            values={value}
            onChange={changeHandler}
            options={options}
          />
        )
      }}
    />
  )
}

export default ControlledMultiSelectGroupInput
